import { Icon, IconsEnum } from 'components/Icons';
import { useCallback, useEffect, useState } from 'react';
import { useDeleteFavouriteBySectionMutation, usePostFavouriteBySectionMutation } from 'features/api/apiSlice';

import { UsersUserDataSectionEnum } from 'types/swagger';
import format from 'date-fns/format';
import styles from './SportFavoriteBtn.module.scss';

export type SportFavoriteBtnProps = {
  idGame: string;
  favourite: boolean;
  verticale: UsersUserDataSectionEnum;
};

export const SportFavoriteBtn = ({ favourite, verticale, idGame }: SportFavoriteBtnProps) => {
  const [fav, setFav] = useState<boolean>(favourite);
  const [trigger] = usePostFavouriteBySectionMutation();
  const [triggerDelete] = useDeleteFavouriteBySectionMutation();
  const handleFavouriteClick = useCallback(
    async (id: string) => {
      const dateTime = new Date();
      if (!fav) {
        await trigger({
          verticale,
          rule: {
            id: id,
            dateTimeSaved: format(dateTime, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
          },
        });
      } else {
        await triggerDelete({
          verticale,
          rule: {
            id: id,
            dateTimeSaved: format(dateTime, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
          },
        });
      }
    },
    [trigger, verticale, triggerDelete, fav]
  );

  useEffect(() => {
    setFav(favourite);
  }, [favourite]);

  return (
    <button
      type="button"
      className={styles.button}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        handleFavouriteClick(idGame);
        setFav((prevState) => !prevState);
      }}
    >
      <span className={styles.iconContainer}>
        <Icon
          iconId={fav ? IconsEnum.PREFERRED_ON : IconsEnum.PREFERRED_OFF}
          className={styles.icon}
          color={fav ? 'var(--color-primary)' : 'var(--color-on-bg-secondary)'}
        />
        {!fav && <Icon iconId={IconsEnum.PREFERRED_OFF_BCK} className={styles.icon} color="transparent" />}
      </span>
    </button>
  );
};
